/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletFreezeActionReqVo
 */
export interface UserWalletFreezeActionReqVo {
    /**
     * 钱包数据编号
     * @type {number}
     * @memberof UserWalletFreezeActionReqVo
     */
    id: number;
    /**
     * 冻结金额数量
     * @type {number}
     * @memberof UserWalletFreezeActionReqVo
     */
    amount: number;
}

/**
 * Check if a given object implements the UserWalletFreezeActionReqVo interface.
 */
export function instanceOfUserWalletFreezeActionReqVo(value: object): value is UserWalletFreezeActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UserWalletFreezeActionReqVoFromJSON(json: any): UserWalletFreezeActionReqVo {
    return UserWalletFreezeActionReqVoFromJSONTyped(json, false);
}

export function UserWalletFreezeActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletFreezeActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
    };
}

export function UserWalletFreezeActionReqVoToJSON(json: any): UserWalletFreezeActionReqVo {
    return UserWalletFreezeActionReqVoToJSONTyped(json, false);
}

export function UserWalletFreezeActionReqVoToJSONTyped(value?: UserWalletFreezeActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
    };
}

